<span [ngClass]="classAvatar">
    {{initial}}
    <i *ngIf="this.icon" class="np" [ngClass]="[this.icon]"></i>
    <i *ngIf="this.done" class="avatar-done np-done iconBody14"></i>
</span>